﻿export class FileUploadComplete {
    static eventName() { return 'FileUploadComplete'; }
    eventName = FileUploadComplete.eventName;

    constructor(public transferId: string, public fileId: string, public newName: string, public newLength: number) { }
}